var chunkMapping = {
	"100": [
		8719
	],
	"252": [
		1252
	],
	"276": [
		3276
	],
	"284": [
		5284
	],
	"292": [
		6911
	],
	"330": [
		4330
	],
	"356": [
		1356
	],
	"412": [
		6412
	],
	"548": [
		9548
	],
	"550": [
		3550
	],
	"562": [
		2562
	],
	"614": [
		1614
	],
	"740": [
		740
	],
	"762": [
		6762
	],
	"815": [
		6815
	],
	"818": [
		8818
	],
	"880": [
		9880
	]
};
var idToExternalAndNameMapping = {
	"740": [
		"default",
		"./FixitTool",
		891
	],
	"1252": [
		"default",
		"./Settings",
		1424
	],
	"1356": [
		"default",
		"./ModuleFederationExample",
		450
	],
	"1614": [
		"default",
		"./TccReportsPlugin",
		7275
	],
	"2562": [
		"default",
		"./VariableRate",
		371
	],
	"3276": [
		"default",
		"./DmbWeb",
		5282
	],
	"3550": [
		"default",
		"./DataInboxWeb",
		5835
	],
	"4330": [
		"default",
		"./ProgramsPlugin",
		347
	],
	"5284": [
		"default",
		"./AppsMarketplacePlugin",
		1395
	],
	"6412": [
		"default",
		"./DataHub",
		9252
	],
	"6762": [
		"default",
		"./TccScriptCreatorPlugin",
		9773
	],
	"6815": [
		"default",
		"./FieldSelectionPlugin",
		9071
	],
	"6911": [
		"default",
		"./CropPlanning",
		8274
	],
	"8719": [
		"default",
		"./InSeasonWeb",
		5935
	],
	"8818": [
		"default",
		"./OperationHub",
		4941
	],
	"9548": [
		"default",
		"./InformationArchitecture",
		4406
	],
	"9880": [
		"default",
		"./Dashboard",
		7139
	]
};
var idToRemoteMap = {
	"740": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 891
		}
	],
	"1252": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 1424
		}
	],
	"1356": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 450
		}
	],
	"1614": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 7275
		}
	],
	"2562": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 371
		}
	],
	"3276": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 5282
		}
	],
	"3550": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 5835
		}
	],
	"4330": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 347
		}
	],
	"5284": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 1395
		}
	],
	"6412": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 9252
		}
	],
	"6762": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 9773
		}
	],
	"6815": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 9071
		}
	],
	"6911": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 8274
		}
	],
	"8719": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 5935
		}
	],
	"8818": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4941
		}
	],
	"9548": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4406
		}
	],
	"9880": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 7139
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}